import { useQuery, useLazyQuery, gql } from "@apollo/client"

const REPORTJOBDETAIL_FIELDS = gql`
  fragment ReportJobDetailFields on ReportJobDetail {
    process {
      name
      steps {
        id
        name
        responseType
      }
    }
    jobs {
      id
      title
      availableFrom
      dueAt
      steps {
        id
        step
        name
        responseType
        response
        responseUploads {
          id
          key
          fileName
          fileGroup
          fileSize
        }
        skip
        completedAt
        completedBy
        notes {
          id
          text
          createdAt
          author {
            id
            fullName
            firstName
            lastName
            avatar {
              key
            }
          }
        }
      }
    }
  }
`

const REPORTJOBDETAIL_QUERY = gql`
  ${REPORTJOBDETAIL_FIELDS}
  query ReportJobDetail($process: ID!, $location: ID!, $gt: ScheduleDateInput!, $lt: ScheduleDateInput) {
    reportJobDetail(process: $process, location: $location, gt: $gt, lt: $lt) {
      ...ReportJobDetailFields
    }
  }
`

const useQueryReportJobDetail = (options) =>
  useQuery(REPORTJOBDETAIL_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

const useLazyQueryReportJobDetail = (options) =>
  useLazyQuery(REPORTJOBDETAIL_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

export { useQueryReportJobDetail, useLazyQueryReportJobDetail }
